import { checkArrayForDuplicates } from '@root/app/utils';
import { Guest } from './Extra/layouts/shared/types';

const propertiesToCheck = ['firstName', 'lastName', 'title'];

export const guestIsDuplicatedExceptGender = (selectedGuests: Guest[]) =>
  checkArrayForDuplicates(selectedGuests, propertiesToCheck);

export const generateGuestLabel = (guest: Guest, selectedGuests: Guest[]) =>
  `${guest.title} ${guest.firstName} ${guest.lastName}${
    guestIsDuplicatedExceptGender(selectedGuests) ? ` (${guest.gender})` : ''
  }`;

export const generateGuestOptions = (
  selectedGuests: (Guest & { title: string })[],
  extraId: number,
  price: string | number
) =>
  selectedGuests.map((guest) => ({
    label: generateGuestLabel(guest, selectedGuests),
    value: guest,
    price,
    id: extraId,
  }));
